export default "__VITE_ASSET__RzzODBrdRYWUt$vEQreizA__"